import { commaListSchema } from "@birdwatch/common";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { SubscriptionsList } from "@/features/admin/subscriptions/list";
import {
  filterSearchFragment,
  withOperators,
} from "@/features/shared/filters-new";
import { maskSearchFragment } from "@/features/shared/route-masking";

const dateRangeSchema = z
  .object({
    start: z.string().optional(),
    end: z.string().optional(),
    label: z.string().optional(),
  })
  .optional()
  .or(z.literal(""));

const searchSchema = z.object({
  filters: z
    .object({
      statusId: withOperators(commaListSchema),
      productKey: withOperators(commaListSchema),
      accountId: withOperators(commaListSchema),
      placeId: withOperators(commaListSchema),
      started: dateRangeSchema,
      ended: dateRangeSchema,
    })
    .optional(),
  ...filterSearchFragment,
  sort: z.string().optional(),
  subscriptionId: z.string().optional(),
  tab: z.string().optional(),
  ...maskSearchFragment,
});

export const Route = createFileRoute("/admin/subscriptions/")({
  validateSearch: searchSchema,
  component: SubscriptionsList,
});
